import type { ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type BadgeTone = 'default' | 'success' | 'warn' | 'danger' | 'info' | 'accent' | 'outline' | 'ink';

type Props = { tone?: BadgeTone; children: ReactNode; className?: string };

const toneClass: Record<BadgeTone, string> = {
  default: '',
  success: 'badge-success',
  warn: 'badge-warn',
  danger: 'badge-danger',
  info: 'badge-info',
  accent: 'badge-accent',
  outline: 'badge-outline',
  ink: 'badge-ink',
};

export const Badge = ({ tone = 'default', children, className }: Props) => (
  <span className={cx('badge', toneClass[tone], className)}>{children}</span>
);
